import setFieldValue from "@bevco/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@bevco/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    shippingAddressLineOne: state.customCreateAccountForm.fieldValues.shippingAddressLineOne,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const shippingAddressLineOneWidget: React.FC<Props> = ({ shippingAddressLineOne, previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Address Line 1");
    const isRequired = !previouslyPurchased || previouslyPurchased === "false";
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, shippingAddressLineOne, "shippingAddressLineOne", () =>
        validateFieldBy(isRequired, label, shippingAddressLineOne, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "shippingAddressLineOne", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={shippingAddressLineOne || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(shippingAddressLineOneWidget);
